import { UserBrief } from 'SharedDir/declarations/user';

export enum HistoryActionType {
  create = 'create',
  update = 'update',
  delete = 'delete',
}

export enum HistoryEntityType {
  persons = 'persons',
  identityDocument = 'identityDocument',
  economicAgreement = 'economicAgreement',
  deer = 'deer',
  household = 'household',
  member = 'member',
  nomadic = 'nomadic',
  ttp = 'ttp',
  personTtp = 'personTtp',
  personThd = 'personThd',
  personRegistry = 'personRegistry',
  personExcerptTtp = 'personExcerptTtp',
  materialResource = 'materialResource',
  act = 'act',
  registryAct = 'registryAct',
  registryMaterialResource = 'registryMaterialResource',
}

export interface GeneralizedHistoryBare {
  action: HistoryActionType;
  entity: HistoryEntityType;
  entityId: number;
  version: number;
  changedBy: number | null;
  changedAt: string | null;
  changedUser: UserBrief | null;
  entityRepr: string | null;
}

export interface GeneralizedHistoryItem extends GeneralizedHistoryBare {
  id: string;
}

export interface GeneralizedHistoryFilters {
  changedBy: number | null;
  action: HistoryActionType | null;
  entity: HistoryEntityType | null;
  changedAtFrom: string | null;
  changedAtTo: string | null;
  entityId: number | null;
  withoutSystem: boolean;
}

export function makeGeneralizedHistoryId(item: GeneralizedHistoryBare): string {
  return `${item.entity}-${item.entityId}-${item.version}`;
}
